import React from 'react'
import cx from 'classnames'

import styles from './Topbar.module.scss'
import SupportIcon from 'Icons/support.svg'
import NotificationIcon from 'Icons/notification.svg'

import UserActions from './UserActions'

const Topbar = () => {
  return (
    <nav className={styles.Container}>
      <div className={styles.Right}>
        <div className={cx(styles.Icon, styles.Pure)} role='button'>
          <NotificationIcon height='15' width='15' />
        </div>
        <div className={cx(styles.Icon, styles.Pure)} role='button'>
          <a
            href='https://support.happyfox.com/kb/section/240/'
            title='HappyFox Support'
            target='_blank'
            rel='noreferrer'
          >
            <SupportIcon height='15' width='15' />
          </a>
        </div>
        <div className={styles.Icon} role='button'>
          <UserActions />
        </div>
      </div>
    </nav>
  )
}

export default Topbar
